import {
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Pagination,
  Box,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import AiSurveyListContent from "./AiSurveyListContent";
import ListToolbar from "../elements/table/ListToolbar";
import ListHead from "../elements/table/ListHead";

export default function AiSurveyTable({
  filteredData,
  fetchData,
  addModal,
  columnFields,
  tableName,
  setMessage,
  setSnackbarOpen,
  page,
  pageSize,
  loading,
  searchTerm,
  handleSearch,
  showSearch = true,
  categories,
  showPagination = false,
  totalPages = 1,
  onPageChange,
}) {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("questionNo");

  const handleRequestSort = (property) => {
    if (property === "questionNo" || property === "category") {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    }
  };

  const startIndex = page * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = showPagination
    ? filteredData.slice(startIndex, endIndex)
    : filteredData;

  const noItemsAdded = !filteredData.length && !searchTerm;
  const isNotFound = !filteredData.length && !!searchTerm;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h5">
          {tableName}
        </Typography>
        {addModal}
      </Stack>

      <Card>
        {showSearch ? (
          <ListToolbar filterName={searchTerm} onFilterName={handleSearch} />
        ) : null}

        <TableContainer sx={{ minWidth: 600, position: "relative" }}>
          <Table>
            <ListHead
              order={order}
              orderBy={orderBy}
              headLabel={columnFields}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={columnFields.length}
                    sx={{ py: 8, textAlign: "center" }}
                  >
                    <CircularProgress size={40} />
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {paginatedData.map((row, index) => (
                    <AiSurveyListContent
                      key={row.id}
                      row={row}
                      columns={columnFields}
                      index={startIndex + index}
                      fetchData={fetchData}
                      tableName={tableName}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                      categories={categories}
                    />
                  ))}

                  {noItemsAdded && (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={columnFields.length}
                        sx={{ py: 3, textAlign: "center" }}
                      >
                        <Typography variant="body2">
                          No {tableName.toLowerCase()}s have been added yet
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}

                  {isNotFound && showSearch && (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={columnFields.length}
                        sx={{ py: 3, textAlign: "center" }}
                      >
                        <Typography variant="body2">
                          No matching {tableName.toLowerCase()}s found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {showPagination && totalPages > 1 && !loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
            <Pagination
              count={totalPages}
              page={page + 1}
              onChange={(event, newPage) => onPageChange(newPage - 1)}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        )}
      </Card>
    </>
  );
}